import find from 'lodash/find';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import ApiToken from 'src/models/Integrations/apiToken';
import analytics from '@ad-scripts/lib/analytics';
import apiTokensResource from 'src/actions/integrations/apiTokensResource';
import { toastError } from 'src/actions/toast';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useSaveTokenName() {
  const dispatch = useDispatch();
  const { values: apiTokensList } = useResourceValues(apiTokensResource);

  const saveHandler = useCallback(
    (item, newName = ''): boolean => {
      const id = item.id;
      const trimmedNewName = newName.trim();
      const lowerCasedName = trimmedNewName.toLowerCase();

      if (!trimmedNewName) {
        dispatch(toastError('Name is required'));
        return false;
      }

      const hasItemWithTheSameName = find(
        apiTokensList,
        (token: ApiToken) => token.id !== id && get(token, 'name', '').toLowerCase() === lowerCasedName
      );

      if (hasItemWithTheSameName) {
        dispatch(toastError('Name already exists'));
        return false;
      }

      dispatch(apiTokensResource.effects.update({ id }, { name: trimmedNewName }, { disableWindowBack: true }));
      analytics.track('Admin - API tokens - Rename', { id, name: trimmedNewName });
      return true;
    },
    [dispatch, apiTokensList]
  );

  return { saveHandler };
}
